module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_vm._v("\n  " + _vm._s(_vm.sortBar.title) + " "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.sortBar.count))]), _vm._v(" "), _c('div', {
    staticClass: "sort-field"
  }, [_vm._v("\n    Sort by:\n    "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.sortBy,
      "options": _vm.sortBy
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          sortBy: $event
        })
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d98c577"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/shared/SortBarComponent.vue
// module id = 1387
// module chunks = 1